interface ResponseModeToggleProps {
  isAsync: boolean;
  onToggle: () => void;
  disabled?: boolean;
}

export function ResponseModeToggle({ isAsync, onToggle, disabled }: ResponseModeToggleProps) {
  return (
    <button
      type="button"
      onClick={onToggle}
      disabled={disabled}
      className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${
        isAsync
          ? 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200'
          : 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200'
      } ${disabled ? 'opacity-50 cursor-not-allowed' : 'hover:opacity-80 cursor-pointer'}`}
      title={isAsync ? 'Click to switch to synchronous mode' : 'Click to switch to asynchronous mode'}
    >
      <span className={`w-2 h-2 rounded-full mr-2 ${isAsync ? 'bg-blue-500' : 'bg-purple-500'}`} />
      {isAsync ? 'Async' : 'Sync'}
    </button>
  );
}
